import loadable from '@loadable/component';

export const CmsImageBlockLoadable = loadable(() => import('./CmsImageBlock'), {
  resolveComponent: (module) => module.CmsImageBlock,
});
